import { createContext } from 'react'
import type {
  LoyaltyActivityEvent,
  LoyaltyActivityEventsResponse,
  LoyaltyActivityFilter,
  LoyaltyActivityRange,
  LoyaltyActivitySummary,
} from '../../../../types/loyalty'

/**
 * Members of the Activity provider — exposed to descendants of the Activity
 * tab.
 *
 * The 4 KPI stat cards are driven by the **activity summary** that the list
 * endpoint returns alongside `items`. The summary respects the current
 * range / tab / search filters server-side, so the cards update as the user
 * narrows the log.
 */
export interface ActivityContextValue {
  storeId: string

  // ── Activity log (paginated list) ───────────────────────────────────────────
  pageData: LoyaltyActivityEventsResponse | undefined
  events: LoyaltyActivityEvent[]
  summary: LoyaltyActivitySummary | undefined
  eventsLoading: boolean
  eventsFetching: boolean
  eventsError: boolean

  // ── Date range filter (top-right select) ────────────────────────────────────
  range: LoyaltyActivityRange
  setRange: (range: LoyaltyActivityRange) => void

  // ── Pill filter (All / Points; Coupons hidden in this release) ──────────────
  filter: LoyaltyActivityFilter
  setFilter: (filter: LoyaltyActivityFilter) => void

  // ── Search (debounced → forwarded to server) ────────────────────────────────
  keyword: string
  setKeyword: (value: string) => void

  // ── Pagination ──────────────────────────────────────────────────────────────
  currentPage: number
  totalPages: number
  totalItems: number
  canGoBack: boolean
  canGoNext: boolean
  goToPrevPage: () => void
  goToNextPage: () => void
  goToPage: (page: number) => void
}

export const ActivityContext = createContext<ActivityContextValue | undefined>(
  undefined,
)
